import styled from "@emotion/styled";

const Row = styled("div")`
  display: flex;
  margin-bottom: 0.5em;

  span {
    flex: 1 1 auto;
  }
`;

export default Row;
